import React, { lazy } from "react";
const Translations = lazy(() => import("../pages/Translations"));
const Treemap = lazy(() => import("../pages/Treemap"));
const WordCloud = lazy(() => import("../pages/WordCloud"));
const QuranStructureExplorer = lazy(() => import("../pages/QuranStructureExplorer"));
const ProphetsGenealogy = lazy(() => import("../pages/ProphetsGenealogy"));
const MirrorsOfDivineWisdom = lazy(() => import("../pages/MirrorsOfDivineWisdom"));
const GeographicalMap = lazy(() => import("../pages/GeographicalMap"));
const AbjadNumerals = lazy(() => import("../pages/AbjadNumerals"));
const EulersNumber = lazy(() => import("../pages/EulersNumber"));
const GoldenRatio = lazy(() => import("../pages/GoldenRatio"));

const Home = lazy(() => import("../pages/Home"));
const About = lazy(() => import("../pages/About"));
const MathAnalysis = lazy(() => import("../pages/blogs/MathAnalysis"));
const MysteriousLetters = lazy(() =>
  import("../pages/blogs/MysteriousLetters")
);
const Bismillah = lazy(() => import("../pages/blogs/Bismillah"));
const NumberNineteen = lazy(() => import("../pages/blogs/NumberNineteen"));
const Graph = lazy(() => import("../pages/blogs/Graph"));
const Blog = lazy(() => import("../pages/blogs/Blog"));
const TheMysteryOfAlFatiha = lazy(() => import("../pages/blogs/TheMysteryOfAlFatiha"));
const Contact = lazy(() => import("../pages/Contact"));
const History = lazy(() => import("../pages/History"));
const Page404 = lazy(() => import("../pages/Page404"));
const LightYears = lazy(() => import("../pages/LightYears"));
const LandSeaRatio = lazy(() => import("../pages/LandSeaRatio"));

const MiracleOfTheBee = lazy(() => import("../pages/MiracleOfTheBee"));
const DivineNamePlot = lazy(() => import("../pages/DivineNamePlot"));
const SymmetriesOfQuran = lazy(() => import("../pages/SymmetriesOfQuran"));
const MiracleOfPrimes = lazy(() => import("../pages/MiracleOfPrimes"));
const AstronomicalReferences = lazy(() => import("../pages/AstronomicalReferences"));
const AsmaAlHusna = lazy(() => import("../pages/AsmaAlHusna"));
const MiraculousNumber114 = lazy(() => import("../pages/MiraculousNumber114"));
const PhysicalConstants = lazy(() => import("../pages/PhysicalConstants"));
const ChromosomeMiracle = lazy(() => import("../pages/ChromosomeMiracle"));
const PeriodicTableMiracle = lazy(() => import("../pages/PeriodicTableMiracle"));
const HarmonyOfNumber777 = lazy(() => import("../pages/HarmonyOfNumber777"));
const SalatMiracle = lazy(() => import("../pages/SalatMiracle"));
const IslamMathematics = lazy(() => import("../pages/IslamMathematics"));
const Ramadhan = lazy(() => import("../pages/Ramadhan"));
const SpeedOfLight = lazy(() => import("../pages/SpeedOfLight"));
const SurahMulkSymmetry = lazy(() => import("../pages/SurahMulkSymmetry"));
const Code19Matrix = lazy(() => import("../pages/Code19Matrix"));
const MuqattaatNetwork = lazy(() => import("../pages/MuqattaatNetwork"));
const FractalCosmos = lazy(() => import("../pages/FractalCosmos"));


const routes = [
  {
    path: "/",
    exact: true,
    component: Home,
    name: "Home Page",
    protected: false,
    element: <Home />,
  },
  {
    path: "/about",
    exact: true,
    component: About,
    name: "About Us Page",
    protected: false,
    element: <About />,
  },
  {
    path: "/contact",
    exact: true,
    component: About,
    name: "Contact Page",
    protected: false,
    element: <Contact />,
  },
  {
    path: "/translations",
    exact: true,
    component: Translations,
    name: "Translations Page",
    protected: false,
    element: <Translations />,
  },
  {
    path: "/treemap",
    exact: true,
    component: Treemap,
    name: "Treemap Page",
    protected: false,
    element: <Treemap />,
  },
  {
    path: "/wordcloud",
    exact: true,
    component: WordCloud,
    name: "Word Cloud Page",
    protected: false,
    element: <WordCloud />,
  },
  {
    path: "/blog",
    exact: true,
    component: Blog,
    name: "Blog Page",
    protected: false,
    element: <Blog />,
  },
  {
    path: "/blog/mathematical-analysis",
    exact: true,
    component: MathAnalysis,
    name: "Mathematical Analysis Blog",
    protected: false,
    element: <MathAnalysis />,
  },
  {
    path: "/mysterious-letters",
    exact: true,
    component: MysteriousLetters,
    name: "Mysterious Letters Blog",
    protected: false,
    element: <MysteriousLetters />,
  },
  {
    path: "/bismillah",
    exact: true,
    component: Bismillah,
    name: "Bismillah Blog",
    protected: false,
    element: <Bismillah />,
  },
  {
    path: "/number-ninenteen",
    exact: true,
    component: NumberNineteen,
    name: "Number Nineteen Blog",
    protected: false,
    element: <NumberNineteen />,
  },
  {
    path: "/graph-visualization",
    exact: true,
    component: Graph,
    name: "Graph Blog",
    protected: false,
    element: <Graph />,
  },
  {
    path: "/the-mystery-of-al-fatiha",
    exact: true,
    component: TheMysteryOfAlFatiha,
    name: "The Mystery of Al-Fatiha Blog",
    protected: false,
    element: <TheMysteryOfAlFatiha />,
  },
  {
    path: "/history-of-the-quran",
    exact: true,
    component: History,
    name: "History of the Quran Page",
    protected: false,
    element: <History />,
  },
  // {
  //   path: "/mathematical-analysis",
  //   exact: true,
  //   component: MathAnalysis,
  //   name: "mathematical Analysis Page",
  //   protected: false,
  //   element: <MathAnalysis />,
  // },
  {
    path: "*",
    exact: false,
    component: Page404,
    name: "404 Page",
    protected: false,
    element: <Page404 />,
  },
  {
    path: "/quran-structure-explorer",
    exact: true,
    component: QuranStructureExplorer,
    name: "Quran Structure Explorer Page",
    protected: false,
    element: <QuranStructureExplorer />,
  },
  {
    path: "/prophets-genealogy",
    exact: true,
    component: ProphetsGenealogy,
    name: "Prophets Genealogy Page",
    protected: false,
    element: <ProphetsGenealogy />,
  },
  {
    path: "/mirrors-of-divine-wisdom",
    exact: true,
    component: MirrorsOfDivineWisdom,
    name: "Mirrors of Divine Wisdom Page",
    protected: false,
    element: <MirrorsOfDivineWisdom />,
  },
  {
    path: "/geographical-map",
    exact: true,
    component: GeographicalMap,
    name: "Geographical Map Page",
    protected: false,
    element: <GeographicalMap />,
  },
  {
    path: "/light-years",
    exact: true,
    component: LightYears,
    name: "Light Years Page",
    protected: false,
    element: <LightYears />,
  },
  {
    path: "/abjad-numerals",
    exact: true,
    component: AbjadNumerals,
    name: "Abjad Numerals Page",
    protected: false,
    element: <AbjadNumerals />,
  },
  {
    path: "/eulers-number",
    exact: true,
    component: EulersNumber,
    name: "Euler's Number Page",
    protected: false,
    element: <EulersNumber />,
  },
  {
    path: "/golden-ratio",
    exact: true,
    component: GoldenRatio,
    name: "Golden Ratio Page",
    protected: false,
    element: <GoldenRatio />,
  },
  {
    path: "/land-sea-ratio",
    exact: true,
    component: LandSeaRatio,
    name: "Land to Sea Ratio Miracle Page",
    protected: false,
    element: <LandSeaRatio />,
  },
  {
    path: "/miracle-of-the-bee",
    exact: true,
    component: MiracleOfTheBee,
    name: "Miracle of the Bee Page",
    protected: false,
    element: <MiracleOfTheBee />,
  },
  {
    path: "/divine-name-plot",
    exact: true,
    component: DivineNamePlot,
    name: "The Divine Name Plot",
    protected: false,
    element: <DivineNamePlot />,
  },
  {
    path: "/symmetries-of-quran",
    exact: true,
    component: SymmetriesOfQuran,
    name: "Symmetries of the Quran",
    protected: false,
    element: <SymmetriesOfQuran />,
  },
  {
    path: "/miracle-of-primes",
    exact: true,
    component: MiracleOfPrimes,
    name: "Miracle of the Prime Number",
    protected: false,
    element: <MiracleOfPrimes />,
  },
  {
    path: "/astronomical-references",
    exact: true,
    component: AstronomicalReferences,
    name: "Astronomical References",
    protected: false,
    element: <AstronomicalReferences />,
  },
  {
    path: "/asma-al-husna",
    exact: true,
    component: AsmaAlHusna,
    name: "99 Names of Allah",
    protected: false,
    element: <AsmaAlHusna />,
  },
  {
    path: "/miraculous-number-114",
    exact: true,
    component: MiraculousNumber114,
    name: "Miraculous Number 114",
    protected: false,
    element: <MiraculousNumber114 />,
  },
  {
    path: "/physical-constants",
    exact: true,
    component: PhysicalConstants,
    name: "Physical Constants",
    protected: false,
    element: <PhysicalConstants />,
  },
  {
    path: "/chromosome-miracle",
    exact: true,
    component: ChromosomeMiracle,
    name: "Chromosome Miracle",
    protected: false,
    element: <ChromosomeMiracle />,
  },
  {
    path: "/periodic-table-miracle",
    exact: true,
    component: PeriodicTableMiracle,
    name: "Periodic Table Miracle",
    protected: false,
    element: <PeriodicTableMiracle />,
  },
  {
    path: "/harmony-of-number-777",
    exact: true,
    component: HarmonyOfNumber777,
    name: "Harmony of Number 777",
    protected: false,
    element: <HarmonyOfNumber777 />,
  },
  {
    path: "/salat-miracle",
    exact: true,
    component: SalatMiracle,
    name: "Salat: Miracle of 2:238",
    protected: false,
    element: <SalatMiracle />,
  },
  {
    path: "/islam-mathematics",
    exact: true,
    component: IslamMathematics,
    name: "Islam & Mathematics",
    protected: false,
    element: <IslamMathematics />,
  },
  {
    path: "/ramadhan",
    exact: true,
    component: Ramadhan,
    name: "Ramadhan",
    protected: false,
    element: <Ramadhan />,
  },
  {
    path: "/speed-of-light",
    exact: true,
    component: SpeedOfLight,
    name: "Speed of Light Miracle",
    protected: false,
    element: <SpeedOfLight />,
  },
  {
    path: "/surah-mulk-symmetry",
    exact: true,
    component: SurahMulkSymmetry,
    name: "The Symmetry of Surah Al-Mulk",
    protected: false,
    element: <SurahMulkSymmetry />,
  },
  {
    path: "/code-19-matrix",
    exact: true,
    component: Code19Matrix,
    name: "Code 19 Matrix",
    protected: false,
    element: <Code19Matrix />,
  },
  {
    path: "/muqattaat-network",
    exact: true,
    component: MuqattaatNetwork,
    name: "The Muqatta'at Network",
    protected: false,
    element: <MuqattaatNetwork />,
  },
  {
    path: "/fractal-cosmos",
    exact: true,
    component: FractalCosmos,
    name: "Fractal Cosmos of the Quran",
    protected: false,
    element: <FractalCosmos />,
  },
];


export default routes;
